export function handleClientPageAnimation() {
    const subSite = document.querySelector('.sub-site-body') as HTMLElement;
    if (!subSite) {
        return;
    }
    const clientComponents = document.querySelectorAll('.client-option');
    clientComponents.forEach(clientComponent => {
        const animationRef = clientComponent.querySelector('.client-animation-ref');

        if (animationRef) {

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        clientComponent.classList.add('visible');
                        observer.unobserve(animationRef);
                    }
                });
            });

            observer.observe(animationRef);
        }
    })
}